<app-nav-superadmin (NewSearchClick)="searchClicked($event)"></app-nav-superadmin>
<div *ngIf="IsSearchPageOpen==0">
    <div class="body-bg container-fluid">
        <div class="row">
            <div class="col-12">
                <app-agentdashboard></app-agentdashboard>
            </div>
        </div>
    </div>
</div>